import React, { useEffect, useState } from "react";
import { Copy, ChevronDown, ChevronRight, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { desktopReportsApi } from "../lib/api";

const kopyala = (t) => navigator.clipboard.writeText(t).then(() => toast.success("Rapor panoya kopyalandı"), () => toast.error("Kopyalanamadı"));

const Satir = ({ r }) => {
  const [acik, setAcik] = useState(false);
  return (
    <div className="border border-white/10 rounded p-2 text-xs font-mono" data-testid={`desktop-report-row-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={() => setAcik(!acik)} className="flex items-center gap-1 text-cyan-200" data-testid={`desktop-report-toggle-${r.id}`}>
          {acik ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
          {new Date(r.created_at).toLocaleString("tr-TR")}
        </button>
        <span className="opacity-80">{r.username}</span>
        <span className="opacity-60">v{r.surum} · {r.platform}</span>
        <button type="button" onClick={() => kopyala(r.metin)} className="text-cyan-300 flex items-center gap-0.5" data-testid={`desktop-report-copy-${r.id}`}>
          <Copy className="h-3 w-3" />Kopyala
        </button>
      </div>
      {acik && <pre className="mt-2 max-h-72 overflow-auto whitespace-pre-wrap text-[10px] opacity-80" data-testid={`desktop-report-text-${r.id}`}>{r.metin}</pre>}
    </div>
  );
};

export const DesktopReportsPanel = () => {
  const [liste, setListe] = useState([]);
  const yenile = () => desktopReportsApi.list().then(setListe).catch(() => setListe([]));
  useEffect(() => { yenile(); }, []);
  return (
    <div className="space-y-2 border-t border-white/10 pt-3 mt-4" data-testid="desktop-reports-panel">
      <div className="flex items-center gap-2">
        <div className="text-sm font-semibold text-cyan-200">Masaüstü sorun raporları</div>
        <button type="button" onClick={yenile} className="text-cyan-300" title="Yenile" data-testid="desktop-reports-refresh"><RefreshCw className="h-3 w-3" /></button>
      </div>
      <div className="text-[11px] opacity-60">Masaüstündeki "Sorun bildir" ile gelen son 20 rapor (şifre/anahtar/jetonlar gizlenmiş).</div>
      <div className="space-y-1" data-testid="desktop-reports-list">
        {liste.map((r) => <Satir key={r.id} r={r} />)}
        {liste.length === 0 && <div className="text-xs opacity-60">Henüz rapor yok.</div>}
      </div>
    </div>
  );
};
